import { useCallback, useMemo } from 'react';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import {
	createInCart,
	updateCartIds,
	updateCartCount,
} from '@fh-components/fh-js-api-core/store/slices/cartSlice';
import { cartInfoSelector } from '@/store';
import { useDispatch, useSelector } from 'react-redux';
import { createSession } from '@fh-components/fh-js-api-core/store/slices/sessionSlice';
import Link from 'next/link';
import { Button } from '@/components';
import getLinkProps from '@/lib/getLinkProps';
import Cookie from 'js-cookie';

const AddToCart = ({
	productId,
	onSuccess,
	isProductConfig = false,
	isWishlist = false,
	inStock,
	buttonProps,
	productInfo = {},
	currentSize = null,
	setIsOpenSize = null,
	ids: configIds = null,
}) => {
	const dispatch = useDispatch();
	const { ids, count } = useSelector(cartInfoSelector);
	const productInCart = (configIds || ids).some(id => id == productId);
	const [cartHref, cartAs] = getLinkProps({ type: 'cart' });

	const isOutOfStock = useMemo(() => {
		if (currentSize === true || !currentSize?.value) {
			return inStock === false;
		}

		return !currentSize.has;
	}, [inStock, currentSize]);

	const addToCart = useCallback(() => {
		const mindboxDeviceUUID = Cookie.get('mindboxDeviceUUID');

		const putIntoCart = () => {
			dispatch(updateCartIds({ ids: [...ids, productId] }));
			dispatch(updateCartCount({ count: count + 1 }));
			dispatch(
				createInCart({
					mindboxDeviceUUID: mindboxDeviceUUID || '',
					id: productId,
					meta: productInfo,
					quantity: 1,
					onSuccess: () => {
						if (window && window.generalPixel) {
							window.generalPixel.postClick('a1');
						}
						onSuccess();
					},
					onError: () => {
						dispatch(createSession(true, undefined, { forceRefresh: true }));
					},
				}),
			);
		};

		if (isProductConfig || isWishlist) {
			if (currentSize) {
				putIntoCart();
			} else {
				setIsOpenSize(true);
			}
		} else {
			putIntoCart();
		}
	}, [
		productId,
		onSuccess,
		dispatch,
		ids,
		count,
		productInfo,
		isProductConfig,
		currentSize,
		setIsOpenSize,
	]);

	return (
		<SwitchTransition>
			<CSSTransition
				key={productInCart ? 'Перейти в корзину' : 'В корзину'}
				timeout={{ appear: 0, enter: 0, exit: 200 }}
				classNames='on'
			>
				{productInCart ? (
					<Link href={cartHref} as={cartAs} passHref>
						<Button {...buttonProps}>В корзине</Button>
					</Link>
				) : (
					<Button {...buttonProps} disabled={isOutOfStock} onClick={addToCart} type='primary'>
						{isOutOfStock ? 'Нет в наличии' : 'В корзину'}
					</Button>
				)}
			</CSSTransition>
		</SwitchTransition>
	);
};

export default AddToCart;
